import { useEffect } from "react";
import { getSocket } from "../../initSocket";

export function useTripRoom(tripId: string) {
  useEffect(() => {
    if (!tripId) return;

    const socket = getSocket();

    console.log("🟢 Map joining room:", tripId);

    socket.emit("joinTripRoom", { tripId });
  }, [tripId]);
}
